var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activation-config-container"},[_c('div',{staticClass:"tab-content-container"},[_c('SurveyEditor',{attrs:{"survey":this.updatedActivation.survey},on:{"change":function($event){_vm.updatedActivation.survey = $event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }